import { z } from 'zod';

const PROXY_BASE = (import.meta.env.VITE_CDC_PROXY_URL as string | undefined) ?? 'http://localhost:8787';

const TestKeySuccess = z.object({ ok: z.literal(true), model: z.string() });
const TestKeyFailure = z.object({
  ok: z.literal(false),
  status: z.number().optional(),
  error: z.unknown().optional(),
  message: z.string().optional(),
});
const TestKeyResponse = z.union([TestKeySuccess, TestKeyFailure]);

export type TestKeyResult = z.infer<typeof TestKeyResponse>;

export async function testApiKey(apiKey: string, model: string): Promise<TestKeyResult> {
  const response = await fetch(`${PROXY_BASE}/v1/messages/test`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Api-Key': apiKey,
    },
    body: JSON.stringify({ model }),
  });
  const json = (await response.json()) as unknown;
  return TestKeyResponse.parse(json);
}
